export default __webpack_public_path__ + "static/media/mun.28ebce3e.svg";